export default __webpack_public_path__ + "static/media/twitter.8a66cb25.svg";